<template>
    <Select v-model="selectedValue" :default-label="defaultLabel" filterable :remote-method="getList"
        :loading="isLoading" :placeholder="placeholder" :label-in-value="true" @on-select="onSelect">
        <Option v-for="(option, index) in list" :value="option.value" :key="index">{{ option.label }}</Option>
    </Select>
</template>

<script>
export default {
    name: 'QHonlineSelect',
    data() {
        return {
            keyword: '',
            list: [],
            loading: false
        };
    },
    props: {
        value: {
            type: [String, Number],
            required: true
        },
        defaultLabel: {
            type: String,
            default: ''
        },
        api: {
            type: Function,
            default: () => { }
        },
        valueName: {
            type: String,
            default: 'value'
        },
        labelName: {
            type: String,
            default: 'label'
        },
        placeholder: {
            type: String,
            default: '请输入关键词搜索并选择'
        },
    },
    computed: {
        selectedValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        isLoading: {
            get() {
                return this.loading;
            }
        }
    },
    mounted() {
        if (!this.$isblank(this.defaultLabel)) {
            this.list = [{
                'value': this.value,
                'label': this.defaultLabel
            }];

        };
    },

    methods: {
        onSelect(value) {
            this.$emit('onSelect', value);
        }, 
        getList(keyword) {
            this.keyword = this.$trimAll(keyword);
            this.$debounce(this._getList, 500, this)(this.keyword);
        },
        _getList(keyword) {
            var that = this;
            if (keyword.length > 1) {
                that.loading = true; // 设置 loading 为 true
                // 参数整合与接口
                const https = {
                    api: that.api,
                    parameter: {
                        keyword: keyword
                    }
                };
                that.$httpsApi(https, (res) => {
                    var list = res.data;
                    var list = list.map(item => ({
                        'value': item[that.valueName],
                        'label': item[that.labelName]
                    }));
                    that.list = list;
                    that.loading = false; // 请求成功后设置 loading 为 false
                }, () => {
                    that.list = [];
                    that.loading = false; // 请求失败后设置 loading 为 false
                });
            };
        }
    }
};
</script>